module.exports = __webpack_public_path__ + "static/media/landing-banner-light.1a28439e.png";